export const GLOSSARIO_REQUEST = "GLOSSARIO_REQUEST";
export const GLOSSARIO_SUCCESS = "GLOSSARIO_SUCCESS";
export const GLOSSARIO_FAIL = "GLOSSARIO_FAIL";
